import Vue from 'vue';
import Router from 'vue-router';
import ViewHome from '@/components/ViewHome';
import ViewPage from '@/components/ViewPage';
import ViewTest from '@/components/ViewTest';
import ViewStories from '@/components/ViewStories';
import ViewProgram from '@/components/ViewProgram';
import ViewPrograms from '@/components/ViewPrograms';
import ViewCategory from '@/components/ViewCategory';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'test',
      path: '/test',
      component: ViewTest,
    }, {
      name: 'home',
      path: '/',
      component: ViewHome,
    }, {
      name: 'programs',
      path: '/programs',
      component: ViewPrograms,
    }, {
      name: 'category',
      path: '/programs/:category',
      component: ViewCategory,
    }, {
      name: 'program',
      path: '/programs/:category/:program',
      component: ViewProgram,
    }, {
      name: 'stories',
      path: '/stories',
      component: ViewStories,
    }, {
      name: 'page',
      path: '/:page',
      component: ViewPage,
      props({ params: { page: slug } }) {
        return { slug };
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});
